export class InfectedResourcesCountResponse {
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "count",
            "baseName": "count",
            "type": "number",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return InfectedResourcesCountResponse.attributeTypeMap;
    }
    constructor() {
    }
}
